"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const common_utils_1 = require("@zapier/common-utils");
const constants_1 = require("../../constants");
const EditablePrettyText_1 = __importDefault(require("../PrettyText/EditablePrettyText"));
const FieldFocusContext_1 = require("../FieldFocusContext/FieldFocusContext");
const FieldFocusContext_2 = require("../FieldFocusContext");
const PrettyText_1 = require("../PrettyText/PrettyText");
const DropdownMenu_1 = __importDefault(require("./DropdownMenu"));
const utils_1 = require("./utils");
const PrettySelectButtonIcon_1 = __importDefault(require("./PrettySelectButtonIcon"));
const PrettySelectButtonLabel_1 = __importDefault(require("./PrettySelectButtonLabel"));
const dropdownNavItems_1 = require("./dropdownNavItems");
const common_1 = require("../common");
const PrettySelect = (props) => {
    const { items, labelsCache = [], metadata, value } = props;
    const { onBlur: onBlurField } = FieldFocusContext_1.useFieldFocusContext();
    const hasCustomValue = utils_1.getHasCustomValue({ items, labelsCache, value });
    const { setVisibleTab, visibleTab } = dropdownNavItems_1.useVisibleTab({ hasCustomValue });
    const [hasSelectedCustomValue, setHasSelectedCustomValue] = react_1.useState(hasCustomValue);
    const [hasManuallyClickedCustomTab, setHasManuallyClickedCustomTab,] = react_1.useState(false);
    const codeMirrorRef = react_1.useRef(null);
    react_1.useLayoutEffect(() => {
        if (dropdownNavItems_1.isCustomTab(visibleTab) &&
            hasManuallyClickedCustomTab &&
            codeMirrorRef.current) {
            codeMirrorRef.current.focusCodeMirror();
        }
    }, [hasManuallyClickedCustomTab, visibleTab]);
    const onSelectTab = (href) => {
        setVisibleTab(href);
        setHasManuallyClickedCustomTab(href === dropdownNavItems_1.OPTION_HREF);
    };
    const onChange = (item) => {
        const newValue = item && utils_1.getOptionValue(item);
        if (dropdownNavItems_1.isOptionTab(visibleTab)) {
            setHasSelectedCustomValue(false);
            props.onChange(newValue, { commit: true, updateInPlace: false });
            onBlurField();
        }
        else if (codeMirrorRef.current) {
            setHasSelectedCustomValue(true);
            codeMirrorRef.current.insertTag(newValue);
        }
    };
    const onUseFallback = (fallback) => {
        if (codeMirrorRef.current) {
            setHasSelectedCustomValue(true);
            codeMirrorRef.current.insertText(fallback);
        }
    };
    function maybeUpdateTab() {
        if (dropdownNavItems_1.isOptionTab(visibleTab)) {
            if (hasCustomValue && hasSelectedCustomValue) {
                onSelectTab(dropdownNavItems_1.CUSTOM_HREF);
            }
        }
        else {
            if (!hasCustomValue && !hasSelectedCustomValue) {
                onSelectTab(dropdownNavItems_1.OPTION_HREF);
            }
        }
    }
    const onBlur = (_e, meta) => {
        if (!meta.didBlurWithin) {
            if (dropdownNavItems_1.isCustomTab(visibleTab)) {
                props.onChange(value, { commit: true, updateInPlace: true });
            }
            meta.closeMenu();
            maybeUpdateTab();
            onBlurField();
        }
    };
    const renderDropdownMenu = (menuProps) => {
        const onClear = () => {
            onChange(null);
        };
        const onSelectAndRemainOpen = (item) => {
            onChange(item);
            props.onLoadOptions(false);
        };
        return (common_utils_1.isolateComponent(DropdownMenu_1.default, Object.assign({}, menuProps, { canAddSearchStep: props.canAddSearchStep, choiceGroups: props.choiceGroups, isLoadingMore: props.isLoadingMore, itemsLabel: props.label, loadMoreState: props.loadMoreState, onAddSearchStep: props.onAddSearchStep, onClear: onClear, onLoadOptions: props.onLoadOptions, onSelectAndRemainOpen: onSelectAndRemainOpen, onSelectTab: onSelectTab, onUseFallback: onUseFallback, shouldShowCustomTab: props.shouldShowCustomTab, visibleTab: visibleTab })));
    };
    const renderButtonForItem = (item) => (common_utils_1.isolateComponent(PrettySelectButtonLabel_1.default, { choiceGroups: props.choiceGroups, item: item, metadata: metadata }));
    const renderIcon = () => dropdownNavItems_1.isOptionTab(visibleTab) ? (common_utils_1.isolateComponent(PrettySelectButtonIcon_1.default, { selectedApi: metadata.selectedApi })) : null;
    const renderCustomContent = ({ css, closeMenu, openMenu, }) => {
        const customValue = dropdownNavItems_1.isCustomTab(visibleTab) && hasCustomValue ? value : undefined;
        const doOnFocus = () => {
            openMenu();
        };
        return (common_utils_1.isolateComponent("div", { "aria-label": "edit field", css: [
                css,
                PrettyText_1.PrettyTextStyles.psuedoInput({
                    isMultiline: false,
                    isEditable: true,
                }),
            ], id: props.id, key: "psuedoInput", onClick: openMenu, onFocus: doOnFocus, role: "presentation" },
            common_utils_1.isolateComponent(EditablePrettyText_1.default, { choiceGroups: props.choiceGroups, initialValue: customValue, onBlur: () => { }, onChange: newValue => {
                    props.onChange(newValue, { commit: false, updateInPlace: true });
                    setHasSelectedCustomValue(true);
                }, onClickTag: () => { }, onEscape: closeMenu, onFocus: doOnFocus, placeholder: constants_1.DEFAULT_PLACEHOLDER_TEXT, ref: codeMirrorRef })));
    };
    const selectedItem = dropdownNavItems_1.isOptionTab(visibleTab) && hasCustomValue
        ? ''
        : utils_1.findOptionForValue({ labelsCache, options: props.items, value }) || '';
    return (common_utils_1.isolateComponent(FieldFocusContext_2.ExclusiveFieldFocus, null,
        common_utils_1.isolateComponent(common_1.Dropdown, Object.assign({}, props, { canClickIconBefore: false, getLabelForItem: utils_1.getOptionLabel, hasCustomContent: dropdownNavItems_1.isCustomTab(visibleTab), items: props.items, menuAriaLabel: props.label, onBlur: onBlur, onChange: onChange, placeholder: props.placeholder, renderButtonForItem: renderButtonForItem, renderCustomContent: renderCustomContent, renderFloatingMenu: renderDropdownMenu, renderIcon: renderIcon, selectedItem: selectedItem }))));
};
PrettySelect.defaultProps = {
    items: null,
    shouldSaveOnBlur: true,
    value: null,
    commitIfChanged: () => { },
};
exports.default = PrettySelect;
